import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMenu } from "../../api/menu/MenuApi";

interface IMenuState {
  menu: IMenu[];
  isReady: boolean;
}

const initialMenuSlice: IMenuState = {
  menu: [],
  isReady: false,
};

const menuSlice = createSlice({
  name: "menuSlice",
  initialState: initialMenuSlice,
  reducers: {
    setMenu: (state, action: PayloadAction<IMenu[]>) => {
      state.menu = action.payload;
      state.isReady = true;
    },
    clearMenu: (state) => {
      state.menu = [];
      state.isReady = false;
    },
    setMenuIsReady: (state, action: PayloadAction<boolean>) => {
      state.isReady = action.payload;
    },
  },
});

export const selectorMenu = (state: { menuSlice: IMenuState }) => state.menuSlice.menu;
export const selectorMenuIsReady = (state: { menuSlice: IMenuState }) =>  state.menuSlice.isReady;
export const { setMenu, clearMenu, setMenuIsReady } = menuSlice.actions;
export default menuSlice.reducer;
